"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkUrlHasDates = checkUrlHasDates;
exports.extractSegmentId = extractSegmentId;
exports.formattedCarouselData = formattedCarouselData;
exports.generateLoadingPercentage = generateLoadingPercentage;
exports.getDisplayedStaticContent = getDisplayedStaticContent;
exports.getHotelDetailUrl = getHotelDetailUrl;
exports.getMapHotelsList = getMapHotelsList;
exports.getPlacementPayload = getPlacementPayload;
exports.getPopularTag = getPopularTag;
exports.getProgressBarStep = getProgressBarStep;
exports.getSearchPriority = getSearchPriority;
exports.getTooManySoldOutState = getTooManySoldOutState;
exports.hasFewDynamicHotels = hasFewDynamicHotels;
exports.mergeStaticAndDynamicHotels = mergeStaticAndDynamicHotels;
exports.paginate = paginate;
exports.staticHotelsParam = staticHotelsParam;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _split6 = _interopRequireDefault(require("lodash/split"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _toLower = _interopRequireDefault(require("lodash/toLower"));
var _orderBy2 = _interopRequireDefault(require("lodash/orderBy"));
var _constants = require("../constants");
var _hotelSummaryCard = require("../factories/hotel-summary-card.factory");
var _date = require("./date.utils");
var _dateFns = require("date-fns");
var _dynamicRankingConstant = require("../dynamicRankingConstant");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * get search priority
 *
 * @description
 * depending on the user selection from autoComplete results either hotel or location
 * or coming to search results directly you will have multiple options to search by
 *
 * @param {String=} query
 * @param {String=} placeId
 * @param {String=} hotelId
 * @param {Array<String>=} hotelsId
 * @param {String=} latitude
 * @param {String=} longitude
 * @returns {string} search by
 */
function getSearchPriority() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    query = _ref.query,
    placeId = _ref.placeId,
    hotelId = _ref.hotelId,
    hotelsId = _ref.hotelsId,
    latitude = _ref.latitude,
    longitude = _ref.longitude;
  if (hotelId || !(0, _isEmpty2["default"])((0, _filter2["default"])(hotelsId, Boolean))) {
    return _constants.SEARCH_PRIORITY.HOTEL_ID;
  }
  if (latitude && longitude) {
    return _constants.SEARCH_PRIORITY.HOTEL_GEO_COORDINATES;
  }
  if (placeId) {
    return _constants.SEARCH_PRIORITY.LOCATION_PLACE_ID;
  }
  return _constants.SEARCH_PRIORITY.QUERY;
}

/**
 * merge static and dynamic hotels
 *
 * @description
 * showing first top priority hotels [only static content]
 * then start updating hotels dynamic content ex: price
 * and any other hotel outside the top priority hotels we pick it from the rest of the static content
 *
 * @param {String} sId
 * @param {String} language
 * @param {String} currency
 * @param {String} distanceDetails
 *
 * @param {Function} formatPrice
 * @param {Function} convertPrice
 *
 * @param {Boolean} isTajawal
 * @param {Boolean} isDev
 * @param {Boolean} pollingCompleted
 *
 * @param {Object} request
 * @param {Object} staticResources
 * @param {Object} staticHotelsHashMap
 * @param {Object} dynamicHotelsHashMap
 * @param {Object} topPriorityHotelsHashMap
 * @param {Boolean} isDesktop
 * @return {Array<Object>} formatted hotels
 * @return {Array<Object>} hotel card images
 */
function mergeStaticAndDynamicHotels(_ref2) {
  var primaryCityId = _ref2.primaryCityId,
    sId = _ref2.sId,
    request = _ref2.request,
    language = _ref2.language,
    currency = _ref2.currency,
    formatPrice = _ref2.formatPrice,
    convertPrice = _ref2.convertPrice,
    isTajawal = _ref2.isTajawal,
    isDev = _ref2.isDev,
    staticResources = _ref2.staticResources,
    staticHotelsHashMap = _ref2.staticHotelsHashMap,
    staticLandmarksHashMap = _ref2.staticLandmarksHashMap,
    hasDates = _ref2.hasDates,
    allStaticContentFetched = _ref2.allStaticContentFetched,
    dynamicHotelsHashMap = _ref2.dynamicHotelsHashMap,
    topPriorityHotelsHashMap = _ref2.topPriorityHotelsHashMap,
    pollingCompleted = _ref2.pollingCompleted,
    distanceDetails = _ref2.distanceDetails,
    distanceDetailsInMeters = _ref2.distanceDetailsInMeters,
    isDesktop = _ref2.isDesktop,
    showPricePerNight = _ref2.showPricePerNight,
    isRtl = _ref2.isRtl;
  var formattedHotels = [];
  var displayedHotels = _objectSpread(_objectSpread({}, getDisplayedStaticContent({
    hasDates: hasDates,
    allStaticContentFetched: allStaticContentFetched,
    staticHotelsHashMap: staticHotelsHashMap,
    topPriorityHotelsHashMap: topPriorityHotelsHashMap
  })), dynamicHotelsHashMap);
  Object.values(displayedHotels).forEach(function (hotel) {
    var hotelId = (0, _get2["default"])(hotel, 'hotelId') || (0, _get2["default"])(hotel, 'atgHotelId');
    var staticHotel = staticHotelsHashMap[hotelId];
    var dynamicHotel = dynamicHotelsHashMap[hotelId];
    var formattedHotel = (0, _hotelSummaryCard.hotelSummaryCardFactory)({
      primaryCityId: primaryCityId,
      dynamicHotel: dynamicHotel,
      sId: sId,
      request: request,
      language: language,
      currency: currency,
      formatPrice: formatPrice,
      convertPrice: convertPrice,
      isTajawal: isTajawal,
      isDev: isDev,
      staticHotel: staticHotel,
      staticResources: staticResources,
      pollingCompleted: pollingCompleted,
      distanceDetails: distanceDetails,
      distanceDetailsInMeters: distanceDetailsInMeters,
      isDesktop: isDesktop,
      showPricePerNight: showPricePerNight,
      isRtl: isRtl,
      staticLandmarksHashMap: staticLandmarksHashMap
    });
    if (formattedHotel.hasStaticContent) {
      formattedHotels.push(formattedHotel);
    }
  });
  return formattedHotels;
}

/**
 * getDisplayedStaticContent
 * @param {Boolean} hasDates
 * @param {Boolean} allStaticContentFetched
 * @param {Object} staticHotelsHashMap
 * @param {Object} topPriorityHotelsHashMap
 * @returns {Object}
 */
function getDisplayedStaticContent(_ref3) {
  var allStaticContentFetched = _ref3.allStaticContentFetched,
    staticHotelsHashMap = _ref3.staticHotelsHashMap,
    topPriorityHotelsHashMap = _ref3.topPriorityHotelsHashMap;
  if (!allStaticContentFetched) {
    return topPriorityHotelsHashMap;
  }
  var keys = Object.keys(staticHotelsHashMap);
  return keys.reduce(function (acc, key) {
    acc[key] = staticHotelsHashMap[key];
    return acc;
  }, {});
}

/**
 * generate loading percentage
 * @param {Boolean} isPollingCompleted
 * @param {Boolean} isSecondProfileFetched
 * @param {Boolean} isFirstProfileFetched
 * @param {Boolean} isStaticHotelsFetched
 * @param {Boolean} isTopPriorityHotelsFetched
 * @param {Boolean} hasDates
 * @return {number} loading percentage
 */
function generateLoadingPercentage(_ref4) {
  var isPollingCompleted = _ref4.isPollingCompleted,
    isSecondProfileFetched = _ref4.isSecondProfileFetched,
    isFirstProfileFetched = _ref4.isFirstProfileFetched,
    isStaticHotelsFetched = _ref4.isStaticHotelsFetched,
    isTopPriorityHotelsFetched = _ref4.isTopPriorityHotelsFetched,
    isSearchIdGenerationFailed = _ref4.isSearchIdGenerationFailed,
    isPollingHasNotStarted = _ref4.isPollingHasNotStarted,
    hasDates = _ref4.hasDates;
  var pollingPercent = function () {
    switch (true) {
      case isPollingHasNotStarted && !hasDates:
      case isSearchIdGenerationFailed && isStaticHotelsFetched:
      case isPollingCompleted:
        return 60;
      case isSecondProfileFetched:
        return 40;
      case isFirstProfileFetched:
        return 20;
      default:
        return 0;
    }
  }();
  var staticContentPercent = function () {
    switch (true) {
      case isStaticHotelsFetched:
        return 40;
      case isTopPriorityHotelsFetched:
        return 20;
      default:
        return 0;
    }
  }();
  return staticContentPercent + pollingPercent;
}

/**
 * calculate pagination
 * @param totalItems
 * @param currentPage
 * @param pageSize
 * @param maxPages
 * @returns {{totalItems: *, startPage: number, startIndex: number, pages: number[], endIndex: number, totalPages: number, pageSize: number, endPage: (number), currentPage: number}}
 */
function paginate(totalItems) {
  var currentPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var pageSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10;
  var maxPages = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 10;
  // calculate total pages
  var totalPages = Math.ceil(totalItems / pageSize);
  currentPage = Math.ceil(currentPage);
  // ensure current page isn't out of range
  if (currentPage < 1) {
    currentPage = 1;
  } else if (currentPage > totalPages) {
    currentPage = totalPages;
  }
  var startPage, endPage;
  if (totalPages <= maxPages) {
    // total pages less than max so show all pages
    startPage = 1;
    endPage = totalPages;
  } else {
    // total pages more than max so calculate start and end pages
    var maxPagesBeforeCurrentPage = Math.floor(maxPages / 2);
    var maxPagesAfterCurrentPage = Math.ceil(maxPages / 2) - 1;
    if (currentPage <= maxPagesBeforeCurrentPage) {
      // current page near the start
      startPage = 1;
      endPage = maxPages;
    } else if (currentPage + maxPagesAfterCurrentPage >= totalPages) {
      // current page near the end
      startPage = totalPages - maxPages + 1;
      endPage = totalPages;
    } else {
      // current page somewhere in the middle
      startPage = currentPage - maxPagesBeforeCurrentPage;
      endPage = currentPage + maxPagesAfterCurrentPage;
    }
  }

  // calculate start and end item indexes
  var startIndex = (currentPage - 1) * pageSize;
  var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

  // create an array of pages to ng-repeat in the pager control
  var pages = Array.from(Array(endPage + 1 - startPage).keys()).map(function (i) {
    return startPage + i;
  });

  // return object with all pager properties required by the view
  return {
    totalItems: totalItems,
    currentPage: currentPage,
    pageSize: pageSize,
    totalPages: totalPages,
    startPage: startPage,
    endPage: endPage,
    startIndex: startIndex,
    endIndex: endIndex,
    pages: pages
  };
}

/**
 * get hotel detail url
 * @param {String} language
 * @param {Number} hotelId
 * @param {String} sId
 * @param {Object} request
 * @param {Boolean} isPriceFetched
 */
function getHotelDetailUrl(_ref5) {
  var language = _ref5.language,
    hotelId = _ref5.hotelId,
    sId = _ref5.sId,
    request = _ref5.request,
    isPriceFetched = _ref5.isPriceFetched;
  var roomsQuery = [];
  var checkIn = (0, _date.reverseDate)((0, _get2["default"])(request, 'checkIn'));
  var checkOut = (0, _date.reverseDate)((0, _get2["default"])(request, 'checkOut'));
  (0, _get2["default"])(request, 'roomsInfo', []).map(function (room) {
    var roomSegment = [];
    roomSegment.push("".concat(room.adultsCount, "_adult"));
    room.kidsAges.length > 0 && roomSegment.push("".concat(room.kidsAges.length, "_child"));
    room.kidsAges.length > 0 && roomSegment.push("".concat(room.kidsAges.join('-'), "_age"));
    roomsQuery.push(roomSegment);
  });
  var queryString = [isPriceFetched ? "sId=".concat(sId) : null, checkIn ? "checkin=".concat(checkIn) : null, checkOut ? "checkout=".concat(checkOut) : null, roomsQuery.length ? "rooms=".concat(roomsQuery.join('*')) : null].filter(Boolean).join('&');
  return "/".concat(language, "/hotel/details/atg/").concat(hotelId).concat(queryString.length ? "?".concat(queryString) : '');
}

/**
 * generate too many sold out state
 * @param {Array<Object>} hotelsList
 * @param {Array<Object>} filteredSortedHotels
 * @param {Boolean} isPollingCompleted
 * @param {Number} dynamicHotelsCount
 */
function getTooManySoldOutState(_ref6) {
  var soldOutHotels = _ref6.soldOutHotels,
    hotelsList = _ref6.hotelsList,
    filteredSortedHotels = _ref6.filteredSortedHotels,
    isPollingCompleted = _ref6.isPollingCompleted,
    hasDynamicHotels = _ref6.hasDynamicHotels;
  return {
    state: hasDynamicHotels && isPollingCompleted && soldOutHotels.length / hotelsList.length >= _constants.TOO_MANY_SOLD_OUT_PERCENT,
    index: (0, _findIndex2["default"])(filteredSortedHotels, function (_ref7) {
      var soldOut = _ref7.soldOut;
      return soldOut;
    })
  };
}

/**
 * has few dynamic hotels
 *
 * @param {Number} soldOutCount
 * @param {Number} hotelsCount
 * @return {boolean}
 */
function hasFewDynamicHotels(_ref8) {
  var soldOutCount = _ref8.soldOutCount,
    hotelsCount = _ref8.hotelsCount;
  if (!soldOutCount && hotelsCount > 0) {
    return false;
  }
  return (hotelsCount - soldOutCount) / soldOutCount <= _constants.FEW_DYNAMIC_HOTELS_PERCENT;
}

/**
 * get progress bar step
 * @param {Boolean} isPollingCompleted
 * @param {Boolean} hasDynamicContent
 * @param {Boolean} canShowResults
 */
function getProgressBarStep(_ref9) {
  var isPollingCompleted = _ref9.isPollingCompleted,
    hasDynamicContent = _ref9.hasDynamicContent,
    canShowResults = _ref9.canShowResults,
    isSearchIdGenerationFailed = _ref9.isSearchIdGenerationFailed,
    allContentFetched = _ref9.allContentFetched,
    isPollingHasNotStarted = _ref9.isPollingHasNotStarted,
    hasDates = _ref9.hasDates;
  var SKELETON = _constants.SEARCH_PROGRESS_STEPS.SKELETON,
    DYNAMIC_CONTENT = _constants.SEARCH_PROGRESS_STEPS.DYNAMIC_CONTENT,
    POLLING_COMPLETED = _constants.SEARCH_PROGRESS_STEPS.POLLING_COMPLETED,
    STATIC_CONTENT = _constants.SEARCH_PROGRESS_STEPS.STATIC_CONTENT;
  switch (true) {
    case isPollingCompleted:
    case isSearchIdGenerationFailed && allContentFetched:
    case isPollingHasNotStarted && !hasDates:
      return POLLING_COMPLETED;
    case hasDynamicContent && canShowResults:
      return DYNAMIC_CONTENT;
    case canShowResults && !hasDynamicContent:
      return STATIC_CONTENT;
    case !canShowResults && !hasDynamicContent:
      return SKELETON;
  }
}
/**
 * checkUrlDates
 * @param {Object} pageUrlData
 * @returns {Boolean}
 */
function checkUrlHasDates(pageUrlData) {
  var _split2 = (0, _split6["default"])((0, _get2["default"])(pageUrlData, 'pageParams.checkOut', ''), '-'),
    _split3 = (0, _slicedToArray2["default"])(_split2, 3),
    checkOut_d = _split3[0],
    checkOut_m = _split3[1],
    checkOut_y = _split3[2];
  var _split4 = (0, _split6["default"])((0, _get2["default"])(pageUrlData, 'pageParams.checkIn', ''), '-'),
    _split5 = (0, _slicedToArray2["default"])(_split4, 3),
    checkIn_d = _split5[0],
    checkIn_m = _split5[1],
    checkIn_y = _split5[2];
  return (0, _dateFns.isValid)(new Date(checkOut_y, checkOut_m, checkOut_d)) && (0, _dateFns.isValid)(new Date(checkIn_y, checkIn_m, checkIn_d));
}

/**
 * getMapHotelsList
 * @param {Array} filteredSortedHotels
 * @param {Array} sortState
 * @return {Array}
 */
function getMapHotelsList(_ref10) {
  var filteredSortedHotels = _ref10.filteredSortedHotels,
    sortState = _ref10.sortState;
  var hotels = filteredSortedHotels.filter(function (hotel) {
    return !(0, _isEqual2["default"])(hotel.coordinates, _constants.INVALID_COORDINATES) && !hotel.soldOut;
  });
  return (0, _orderBy2["default"])(hotels, [sortState.LOWEST_PRICE.field], ['desc', 'asc']);
}

/**
 * Extract Segment Id
 * @param {String} segmentValues
 * @return {String}
 */
function extractSegmentId(_ref11) {
  var segmentValues = _ref11.segmentValues;
  var segmentIdItem = segmentValues && _dynamicRankingConstant.DYNAMIC_RANKING_CONSTANT.filter(function (segmentItem) {
    return segmentItem.segmentCriteria === segmentValues;
  });
  return segmentIdItem !== null && segmentIdItem !== void 0 && segmentIdItem.length ? segmentIdItem[0].segmentId : '0';
}

/**
 * Extract getPopularTag
 * @param {Object} city
 * @param {Object} bookingHistory
 */
function getPopularTag(_ref12) {
  var city = _ref12.city,
    bookingHistory = _ref12.bookingHistory;
  if (_constants.BOOKING_HISTORY_CONSTANT[(0, _toLower["default"])(city.nameEn)]) {
    return (bookingHistory === null || bookingHistory === void 0 ? void 0 : bookingHistory.last7DaysBookingsRounded) >= _constants.BOOKING_HISTORY_CONSTANT[(0, _toLower["default"])(city.nameEn)];
  }
  return (bookingHistory === null || bookingHistory === void 0 ? void 0 : bookingHistory.last7DaysBookingsRounded) >= 10;
}

/**
 * Extract AdbutlerPayload
 * @param {Object} city
 * @param {Object} bookingHistory
 */
function getPlacementPayload(_ref13) {
  var _config$posConfig, _config$posConfig$con, _searchRequest$roomsI;
  var config = _ref13.config,
    language = _ref13.language,
    searchRequest = _ref13.searchRequest,
    guests = _ref13.guests,
    countryCode = _ref13.countryCode,
    cityEnNameHotel = _ref13.cityEnNameHotel;
  var pax = (guests === null || guests === void 0 ? void 0 : guests.adults) + (guests === null || guests === void 0 ? void 0 : guests.children);
  var payload = {
    pos: (_config$posConfig = config.posConfig) === null || _config$posConfig === void 0 ? void 0 : (_config$posConfig$con = _config$posConfig[config === null || config === void 0 ? void 0 : config.countryCode]) === null || _config$posConfig$con === void 0 ? void 0 : _config$posConfig$con.code,
    language: language,
    check_in_date: (searchRequest === null || searchRequest === void 0 ? void 0 : searchRequest.checkIn) && (0, _date.convertToMMDDYYYY)(searchRequest === null || searchRequest === void 0 ? void 0 : searchRequest.checkIn),
    check_out_date: (searchRequest === null || searchRequest === void 0 ? void 0 : searchRequest.checkOut) && (0, _date.convertToMMDDYYYY)(searchRequest === null || searchRequest === void 0 ? void 0 : searchRequest.checkOut),
    room_count: (searchRequest === null || searchRequest === void 0 ? void 0 : (_searchRequest$roomsI = searchRequest.roomsInfo) === null || _searchRequest$roomsI === void 0 ? void 0 : _searchRequest$roomsI.length) || 1,
    pax_count: pax || 2,
    country_code: countryCode,
    city_name_en: cityEnNameHotel
  };
  return {
    zoneIDs: config.isLive ? [708387, 711467, 731173, 762539] : [715922, 718566, 729132, 753542],
    kw: [searchRequest === null || searchRequest === void 0 ? void 0 : searchRequest.query],
    dataKeys: payload
  };
}
function staticHotelsParam(_ref14) {
  var hotelId = _ref14.hotelId,
    latitude = _ref14.latitude,
    longitude = _ref14.longitude,
    placeId = _ref14.placeId,
    query = _ref14.query,
    timeout = _ref14.timeout,
    pageSize = _ref14.pageSize;
  var searchBy = getSearchPriority({
    hotelId: hotelId,
    latitude: latitude,
    longitude: longitude,
    placeId: placeId,
    query: query,
    timeout: timeout
  });
  var minPageSize = Math.min(pageSize, 9300);
  switch (searchBy) {
    case _constants.SEARCH_PRIORITY.HOTEL_ID:
      return {
        hotelId: hotelId,
        pageSize: minPageSize,
        timeout: timeout
      };
    case _constants.SEARCH_PRIORITY.HOTEL_GEO_COORDINATES:
      return {
        latitude: latitude,
        longitude: longitude,
        pageSize: minPageSize,
        timeout: timeout
      };
    case _constants.SEARCH_PRIORITY.LOCATION_PLACE_ID:
      return {
        placeId: placeId,
        pageSize: minPageSize,
        timeout: timeout
      };
    case _constants.SEARCH_PRIORITY.QUERY:
      return {
        query: query,
        pageSize: minPageSize,
        timeout: timeout
      };
  }
}
function formattedCarouselData(data, language) {
  var _data$trustYouReviews, _data$filterData, _data$totalRateInfo, _data$totalRateInfo2, _data$totalRateInfo3, _data$totalRateInfo4, _data$perNightRateInf, _data$perNightRateInf2, _data$perNightRateInf3, _data$perNightRateInf4;
  return _objectSpread(_objectSpread({}, data), {}, {
    id: data.hotelId,
    name: data.hotelName,
    score: (_data$trustYouReviews = data.trustYouReviews) === null || _data$trustYouReviews === void 0 ? void 0 : _data$trustYouReviews.score,
    rooms: ((_data$filterData = data.filterData) === null || _data$filterData === void 0 ? void 0 : _data$filterData.rooms) || 1,
    nights: data.stayingNights || 1,
    address: data.address,
    stars: data.starRating,
    img: data.coverImg,
    language: language,
    topPick: {
      title: data.topPick ? data.topPick.category : '',
      icon: data.topPick ? data.topPick.categoryIcon : ''
    },
    totalRateInfo: {
      finalRate: data === null || data === void 0 ? void 0 : (_data$totalRateInfo = data.totalRateInfo) === null || _data$totalRateInfo === void 0 ? void 0 : _data$totalRateInfo.finalRate,
      originalRate: (_data$totalRateInfo2 = data.totalRateInfo) === null || _data$totalRateInfo2 === void 0 ? void 0 : _data$totalRateInfo2.originalRate,
      discount: ((_data$totalRateInfo3 = data.totalRateInfo) === null || _data$totalRateInfo3 === void 0 ? void 0 : _data$totalRateInfo3.discount) || 0,
      currency: (_data$totalRateInfo4 = data.totalRateInfo) === null || _data$totalRateInfo4 === void 0 ? void 0 : _data$totalRateInfo4.currency
    },
    perNightRateInfo: {
      finalRate: data === null || data === void 0 ? void 0 : (_data$perNightRateInf = data.perNightRateInfo) === null || _data$perNightRateInf === void 0 ? void 0 : _data$perNightRateInf.finalRate,
      originalRate: (_data$perNightRateInf2 = data.perNightRateInfo) === null || _data$perNightRateInf2 === void 0 ? void 0 : _data$perNightRateInf2.originalRate,
      discount: ((_data$perNightRateInf3 = data.perNightRateInfo) === null || _data$perNightRateInf3 === void 0 ? void 0 : _data$perNightRateInf3.discount) || 0,
      currency: (_data$perNightRateInf4 = data.perNightRateInfo) === null || _data$perNightRateInf4 === void 0 ? void 0 : _data$perNightRateInf4.currency
    },
    soldOut: data.soldOut
  });
}